import { composeIO } from 'react-compose-io'
import { dadosTiposLancamentosIO } from './DadosTiposLancamentos.IO'
import { DadosTiposLancamentosView } from './DadosTiposLancamentos.View'

export const DadosTiposLancamentos = composeIO(DadosTiposLancamentosView, dadosTiposLancamentosIO)
